import type { Address } from '@/core/graphql/generated/types';

export const getPrimaryAddress = (
	addresses: Address[] | null | undefined
): Address | undefined =>
	addresses?.find(a => a.primaryCda_V) ?? addresses?.[0] ?? undefined;
